import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const getCookieValue = (name) => {
  const cookie = document.cookie
    .split(';')
    .map((row) => row.trim())
    .find((row) => row.startsWith(`${name}=`));
  return cookie ? decodeURIComponent(cookie.split('=').slice(1).join('=')) : '';
};

const inputStyle = {
  width: '100%',
  padding: '10px',
  margin: '8px 0 16px',
  borderRadius: '6px',
  border: '1px solid #ccc',
  fontSize: '1rem',
  fontFamily: "'Nunito', sans-serif"
};

const buttonStyle = {
  width: '100%',
  padding: '12px',
  borderRadius: '6px',
  backgroundColor: '#4dabf7',
  color: '#fff',
  fontWeight: 'bold',
  fontSize: '1rem',
  border: 'none',
  cursor: 'pointer',
  transition: 'background 0.2s'
};

// Predefined categories
const availableCategories = [
  "Audio Books",
  "Automotive/EVs",
  "Books",
  "Charity/Fundraising",
  "Coders/Web Developers",
  "Collectibles",
  "Comics",
  "Consulting",
  "Cosplay",
  "Courses/Tutorials",
  "Craftwork",
  "Digital Backgrounds",
  "Ebooks",
  "EZines",
  "Finance/Investing",
  "Gaming",
  "Illustration",
  "Music",
  "NFT Art",
  "Photography",
  "Podcasting",
  "Printables",
  "Stationery",
  "Stickers",
  "Streamers",
  "Video Creation",
  "Vlogging",
  "Virtual Assistants",
  "Writing/Blogging",
];

function SubmitForm() {
  const [formData, setFormData] = useState({
    name: '',
    kofi_url: '',
    description: '',
    avatar_url: '',
    categories: [],
    customCategory: '',
  });

  const [success, setSuccess] = useState(false);
  const [kofiCheck, setKofiCheck] = useState({ status: 'idle', message: '' });
  const latestKofiCheck = useRef(0);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === 'kofi_url') {
      latestKofiCheck.current += 1;
      setKofiCheck({ status: 'idle', message: '' });
    }
  };

  const checkKofiLink = async () => {
    const value = formData.kofi_url.trim();
    if (!value) return;

    const checkId = latestKofiCheck.current + 1;
    latestKofiCheck.current = checkId;
    setKofiCheck({ status: 'checking', message: 'Checking directory…' });
    try {
      const response = await axios.get(`${API_BASE}/submissions/check-kofi`, {
        params: { url: value },
      });

      if (latestKofiCheck.current !== checkId) return;

      if (response.data.exists) {
        setKofiCheck({
          status: 'duplicate',
          message: 'This profile is already in the directory.',
        });
      } else {
        setKofiCheck({ status: 'available', message: '' });
      }
    } catch (err) {
      if (latestKofiCheck.current !== checkId) return;
      if (err.response?.status === 400) {
        setKofiCheck({
          status: 'invalid',
          message: err.response.data?.error || 'Enter a valid Ko-fi creator link.',
        });
      } else {
        setKofiCheck({
          status: 'unavailable',
          message: 'We could not check the directory right now. You can still try submitting.',
        });
      }
    }
  };

  const handleCategoryChange = (category) => {
    if (formData.categories.includes(category)) {
      setFormData({
        ...formData,
        categories: formData.categories.filter(c => c !== category),
      });
    } else {
      setFormData({
        ...formData,
        categories: [...formData.categories, category],
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (kofiCheck.status === 'duplicate' || kofiCheck.status === 'invalid') return;
    try {
      // Merge custom category if provided
      const finalCategories = [...formData.categories];
      if (formData.customCategory.trim()) {
        finalCategories.push(formData.customCategory.trim());
      }
      const datafastVisitorId = getCookieValue('datafast_visitor_id');

      await axios.post(
        `${API_BASE}/submissions`,
        {
          type: 'creator',
          name: formData.name,
          kofi_url: formData.kofi_url,
          description: formData.description,
          avatar_url: formData.avatar_url,
          categories: finalCategories,
          datafast_visitor_id: datafastVisitorId,
        },
        {
          headers: {
            'x-datafast-visitor-id': datafastVisitorId,
          },
        }
      );

      setSuccess(true);
      setFormData({ name: '', kofi_url: '', description: '', avatar_url: '', categories: [], customCategory: '' });
    } catch (err) {
      if (err.response?.status === 409) {
        setKofiCheck({
          status: 'duplicate',
          message: 'This profile is already in the directory.',
        });
      } else if (err.response?.status === 400) {
        setKofiCheck({
          status: 'invalid',
          message: err.response.data?.error || 'Enter a valid Ko-fi creator link.',
        });
      } else {
        alert('Error submitting creator: ' + err.message);
      }
    }
  };

  return (
    <div style={{
      maxWidth: '500px',
      margin: '40px auto',
      padding: '20px',
      borderRadius: '10px',
      background: '#f9f9f9',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
      fontFamily: "'Nunito', sans-serif"
    }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Submit Your Ko-fi</h2>
      <p style={{ fontSize: '0.85rem', color: '#444', marginBottom: '20px', textAlign: 'center' }}>
        Are you a creator on Ko-fi? Add yourself to our public directory!  
        Your profile will be displayed as a large featured card on this website instantly! <br />
        <h3>ONLY 1 SUBMISSION PER PERSON PLEASE</h3> <br />
        For any corrections after submission, please <a href="https://ko-fi.com/emanoj" target="_blank" rel="noopener noreferrer" style={{ color: '#4dabf7', textDecoration: 'underline' }}>message me on Ko-fi </a>
        or through the <a href="https://tally.so/r/w8qkjP" target="_blank" rel="noopener noreferrer" style={{ color: '#4dabf7', textDecoration: 'underline' }}> Contact Form </a>
      
      </p>

      {success && <p style={{ color: 'green', textAlign: 'center' }}>Thanks for submitting!</p>}

      <form onSubmit={handleSubmit}>
        <label>Name</label>
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <label>Ko-fi Link</label>
        <input
          name="kofi_url"
          value={formData.kofi_url}
          onChange={handleChange}
          onBlur={checkKofiLink}
          required
          style={inputStyle}
        />
        <small style={{ color: '#888', fontStyle: 'italic' }}>
          e.g: https://ko-fi.com/your-page-name
        </small>
        {kofiCheck.status === 'checking' && (
          <div style={{ marginTop: '10px', color: '#555', fontWeight: 'bold' }}>
            {kofiCheck.message}
          </div>
        )}
        {(kofiCheck.status === 'duplicate' || kofiCheck.status === 'invalid') && (
          <div
            role="alert"
            style={{
              marginTop: '10px',
              padding: '10px 12px',
              border: '1px solid #e7a4a4',
              borderRadius: '6px',
              backgroundColor: '#fff0f0',
              color: '#a61b1b',
              fontWeight: 'bold',
              lineHeight: '1.45',
            }}
          >
            {kofiCheck.message}{' '}
            {kofiCheck.status === 'duplicate' && (
              <Link to="/creators" style={{ color: '#8b1111' }}>
                Search for it on the All Creators page.
              </Link>
            )}
          </div>
        )}
        {kofiCheck.status === 'unavailable' && (
          <div style={{ marginTop: '10px', color: '#765b00', fontWeight: 'bold' }}>
            {kofiCheck.message}
          </div>
        )}
        <br /><br />

        <label>Profile Picture URL (optional)</label>
        <input
          name="avatar_url"
          value={formData.avatar_url}
          onChange={handleChange}
          placeholder="https://example.com/your-image.jpg"
          style={inputStyle}
        />
        <small style={{ color: '#888', fontStyle: 'italic' }}>
          Tip: Go to your Ko-fi page → Right-click your profile pic → Copy image address → Paste it above
        </small>
        <br /><br />

        <label>Description</label>
        <textarea
          name="description"
          maxLength={250}
          value={formData.description}
          onChange={handleChange}
          required
          rows={4}
          style={{ ...inputStyle, resize: 'vertical' }}
        />
        <p>{formData.description.length}/250 characters max</p>

        <h4 style={{ marginTop: '24px' }}>Choose Categories (select multiple):</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
          {availableCategories.map(category => (
            <label key={category} style={{ fontSize: '0.9rem' }}>
              <input
                type="checkbox"
                checked={formData.categories.includes(category)}
                onChange={() => handleCategoryChange(category)}
                style={{ marginRight: '6px' }}
              />
              {category}
            </label>
          ))}
        </div>

        <input
          name="customCategory"
          placeholder="Suggest a new category (optional)"
          value={formData.customCategory}
          onChange={handleChange}
          style={inputStyle}
        />

        <button
          type="submit"
          disabled={kofiCheck.status === 'duplicate' || kofiCheck.status === 'invalid' || kofiCheck.status === 'checking'}
          style={{
            ...buttonStyle,
            opacity: kofiCheck.status === 'duplicate' || kofiCheck.status === 'invalid' || kofiCheck.status === 'checking' ? 0.55 : 1,
            cursor: kofiCheck.status === 'duplicate' || kofiCheck.status === 'invalid' || kofiCheck.status === 'checking' ? 'not-allowed' : 'pointer',
          }}
        >
          Submit
        </button>
      </form>
    </div>
  );
}

export default SubmitForm;
